import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

const recordGithubAppInstallationSchema = z.object({
  connectedAppId: z.string(),
  installationId: z.string().regex(/^\d+$/),
});

export const recordGithubAppInstallation = mutator({
  schema: recordGithubAppInstallationSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, installationId } }) => {
    if (app.identifier !== "githubApp")
      throw userFacingError("Not a GitHub App connector.");
    await tx.mutate.connectedApps.update({
      id: app.id,
      configuration: {
        ...(app.configuration as Record<string, string>),
        installationId,
      },
    });
  },
});
